import React from 'react'
import { Link } from 'react-router-dom'
// import herobg from '/img/hero-banner.jpeg'
const Hero = () => {
  return (
    <>
      <section class="relatve mt-8 ">
        {/* <!-- Container --> */}
        <div class="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-24 lg:py-32">
          {/* <!-- Heading Div --> */}
          <div class="mx-auto mb-12 w-full max-w-3xl text-center md:mb-16 lg:mb-20" >
            <h1
              data-aos="flip-down"
              class="mb-4 text-4xl font-semibold md:text-5xl !leading-snug">Learn Dental Like Never Before with <span class="bg-cover bg-center px-4 text-white shadow-[rgb(19,83,254)_6px_6px]" style={{ backgroundImage: "url(/img/hero-svg-img.png)" }}>Ajay kumar BDS</span></h1>

            {/* Silent Features Section */}
            <div className="my-10 mx-[-16px] sm:mx-auto w-[calc(100%+32px)] sm:w-full max-w-4xl text-center px-1">
              {/* Divider with tooth decoration */}
              <div className="flex items-center justify-center gap-3 mb-3">
                {/* Left line (fading purple gradient) */}
                <div className="h-[1.5px] w-16 sm:w-28 bg-gradient-to-r from-transparent to-[#7c3aed] flex-shrink-0"></div>

                {/* Center Ornaments */}
                <div className="flex items-center gap-2 text-[#7c3aed] flex-shrink-0">
                  {/* Left sparkles */}
                  <div className="relative w-8 h-8 flex-shrink-0">
                    {/* Small sparkle at bottom-left */}
                    <svg className="absolute bottom-[2px] left-[2px] w-2.5 h-2.5 text-[#7c3aed] fill-current" viewBox="0 0 24 24">
                      <path d="M12 2l2 8 8 2-8 2-2 8-2-8-8-2 8-2z" />
                    </svg>
                    {/* Large sparkle at top-right */}
                    <svg className="absolute top-[2px] right-[2px] w-3.5 h-3.5 text-[#7c3aed] fill-current" viewBox="0 0 24 24">
                      <path d="M12 2l2 8 8 2-8 2-2 8-2-8-8-2 8-2z" />
                    </svg>
                  </div>

                  {/* Tooth SVG */}
                  <svg className="w-7 h-7 text-[#7c3aed] fill-current mx-0.5" viewBox="0 0 100 100">
                    <path d="M 50 24 C 40 24, 30 18, 24 30 C 18 42, 22 55, 28 60 C 24 72, 26 88, 32 90 C 38 92, 44 75, 48 65 C 49 61, 51 61, 52 65 C 56 75, 62 92, 68 90 C 74 88, 76 72, 72 60 C 78 55, 82 42, 76 30 C 70 18, 60 24, 50 24 Z" />
                  </svg>

                  {/* Right sparkles */}
                  <div className="relative w-8 h-8 flex-shrink-0">
                    {/* Large sparkle at top-left */}
                    <svg className="absolute top-[2px] left-[2px] w-3.5 h-3.5 text-[#7c3aed] fill-current" viewBox="0 0 24 24">
                      <path d="M12 2l2 8 8 2-8 2-2 8-2-8-8-2 8-2z" />
                    </svg>
                    {/* Small sparkle at bottom-right */}
                    <svg className="absolute bottom-[2px] right-[2px] w-2.5 h-2.5 text-[#7c3aed] fill-current" viewBox="0 0 24 24">
                      <path d="M12 2l2 8 8 2-8 2-2 8-2-8-8-2 8-2z" />
                    </svg>
                  </div>
                </div>

                {/* Right line (fading purple gradient) */}
                <div className="h-[1.5px] w-16 sm:w-28 bg-gradient-to-l from-transparent to-[#7c3aed] flex-shrink-0"></div>
              </div>

              <h2 className="text-3xl min-[360px]:text-3.5xl min-[400px]:text-4xl sm:text-5.5xl md:text-7xl font-extrabold tracking-wider mb-8 bg-gradient-to-r from-[#0b33ad] via-[#7c3aed] to-[#e21b79] bg-clip-text text-transparent uppercase leading-none whitespace-nowrap">
                KEY FEATURES
              </h2>

              <div className="flex flex-nowrap justify-between sm:justify-center gap-1 sm:gap-6 overflow-hidden w-full px-1">
                {/* Item 1: Complete Notes */}
                <div className="flex flex-col items-center text-center w-[18%] sm:w-auto flex-shrink-0">
                  <div className="w-11 h-11 min-[360px]:w-12 min-[360px]:h-12 sm:w-16 sm:h-16 flex items-center justify-center mb-1.5 sm:mb-2">
                    <svg viewBox="0 0 64 64" className="w-full h-full" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 4h26l14 14v38a4 4 0 01-4 4H12a4 4 0 01-4-4V8a4 4 0 014-4z" fill="#1353fe" />
                      <path d="M38 4v14h14L38 4z" fill="#0d3cb3" />
                      <rect x="16" y="28" width="32" height="4" rx="2" fill="white" />
                      <rect x="16" y="38" width="32" height="4" rx="2" fill="white" />
                      <rect x="16" y="48" width="20" height="4" rx="2" fill="white" />
                      <circle cx="48" cy="48" r="10" fill="#1353fe" stroke="white" strokeWidth="3" />
                      <path d="M43 48L46.5 51.5L53 45" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <span className="text-[7.5px] min-[360px]:text-[8.5px] sm:text-[10px] font-bold text-[#1353fe] leading-tight uppercase tracking-wider">Complete<br />Notes</span>
                </div>

                {/* Divider 1 */}
                <div className="w-[1px] h-9 sm:h-14 bg-gray-200 self-center flex-shrink-0 my-auto"></div>

                {/* Item 2: Priority-Wise Questions */}
                <div className="flex flex-col items-center text-center w-[18%] sm:w-auto flex-shrink-0">
                  <div className="w-11 h-11 min-[360px]:w-12 min-[360px]:h-12 sm:w-16 sm:h-16 flex items-center justify-center mb-1.5 sm:mb-2">
                    <svg viewBox="0 0 64 64" className="w-full h-full" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="12" y="8" width="40" height="48" rx="6" stroke="#15803d" strokeWidth="4.5" fill="#f4fbf7" />
                      <path d="M25 8V6a2 2 0 012-2h10a2 2 0 012 2v2" fill="#15803d" stroke="#15803d" strokeWidth="1" strokeLinecap="round" />
                      <path d="M18 20l4 4 8-8" stroke="#15803d" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
                      <rect x="34" y="20" width="14" height="4" rx="2" fill="#15803d" />
                      <path d="M18 34l4 4 8-8" stroke="#15803d" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
                      <rect x="34" y="34" width="14" height="4" rx="2" fill="#15803d" />
                      <path d="M18 48l4 4 8-8" stroke="#15803d" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
                      <rect x="34" y="48" width="14" height="4" rx="2" fill="#15803d" />
                    </svg>
                  </div>
                  <span className="text-[7.5px] min-[360px]:text-[8.5px] sm:text-[10px] font-bold text-[#15803d] leading-tight uppercase tracking-wider">Priority-Wise<br />Questions</span>
                </div>

                {/* Divider 2 */}
                <div className="w-[1px] h-9 sm:h-14 bg-gray-200 self-center flex-shrink-0 my-auto"></div>

                {/* Item 3: Flash Card List */}
                <div className="flex flex-col items-center text-center w-[18%] sm:w-auto flex-shrink-0">
                  <div className="w-11 h-11 min-[360px]:w-12 min-[360px]:h-12 sm:w-16 sm:h-16 flex items-center justify-center mb-1.5 sm:mb-2">
                    <svg viewBox="0 0 64 64" className="w-full h-full" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="11" y="13" width="42" height="34" rx="4" fill="#ffedd5" stroke="#f97316" strokeWidth="3" transform="rotate(-7 32 30)" />
                      <rect x="13" y="12" width="42" height="34" rx="4" fill="#fed7aa" stroke="#ea580c" strokeWidth="3" transform="rotate(-3.5 34 29)" />
                      <rect x="16" y="14" width="42" height="34" rx="4" fill="#ea580c" />
                      {/* Large Tooth symbol centered on front card using transformed path */}
                      <g transform="translate(25, 19) scale(0.24)">
                        <path d="M 50 20 C 42 20, 32 15, 26 28 C 22 36, 24 48, 28 55 C 25 65, 28 85, 33 87 C 38 89, 44 72, 47 62 C 48 57, 52 57, 53 62 C 56 72, 62 89, 67 87 C 72 85, 75 65, 72 55 C 76 48, 78 36, 74 28 C 68 15, 58 20, 50 20 Z" fill="white" />
                      </g>
                      <circle cx="21" cy="20" r="2.5" fill="#7c2d12" />
                      <path d="M21 20C21 15.5 17.5 12.5 14 15C10.5 17.5 11 22.5 15.5 22.5" stroke="#9a3412" strokeWidth="2.5" strokeLinecap="round" fill="none" />
                    </svg>
                  </div>
                  <span className="text-[7.5px] min-[360px]:text-[8.5px] sm:text-[10px] font-bold text-[#ea580c] leading-tight uppercase tracking-wider">Flash Card<br />List</span>
                </div>

                {/* Divider 3 */}
                <div className="w-[1px] h-9 sm:h-14 bg-gray-200 self-center flex-shrink-0 my-auto"></div>

                {/* Item 4: Chapter-Wise Flash Card Videos */}
                <div className="flex flex-col items-center text-center w-[18%] sm:w-auto flex-shrink-0">
                  <div className="w-11 h-11 min-[360px]:w-12 min-[360px]:h-12 sm:w-16 sm:h-16 flex items-center justify-center mb-1.5 sm:mb-2">
                    <svg viewBox="0 0 64 64" className="w-full h-full" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="6" y="10" width="52" height="38" rx="8" fill="#7c3aed" />
                      <path d="M26 21L42 29L26 37V21Z" fill="white" />
                      <rect x="12" y="41" width="40" height="3" rx="1.5" fill="#c084fc" />
                      <circle cx="18" cy="42.5" r="4.5" fill="white" />
                    </svg>
                  </div>
                  <span className="text-[7.5px] min-[360px]:text-[8.5px] sm:text-[10px] font-bold text-[#7c3aed] leading-tight uppercase tracking-wider">Chapter-Wise<br />Flash Card Videos</span>
                </div>

                {/* Divider 4 */}
                <div className="w-[1px] h-9 sm:h-14 bg-gray-200 self-center flex-shrink-0 my-auto"></div>

                {/* Item 5: Exam-Focused Resources */}
                <div className="flex flex-col items-center text-center w-[18%] sm:w-auto flex-shrink-0">
                  <div className="w-11 h-11 min-[360px]:w-12 min-[360px]:h-12 sm:w-16 sm:h-16 flex items-center justify-center mb-1.5 sm:mb-2">
                    <svg viewBox="0 0 64 64" className="w-full h-full" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="10" y="6" width="44" height="52" rx="6" stroke="#db2777" strokeWidth="4.5" fill="#fdf2f8" />
                      <circle cx="20" cy="20" r="3.5" fill="#db2777" />
                      <rect x="28" y="18" width="18" height="4" rx="2" fill="#db2777" />
                      <circle cx="20" cy="32" r="3.5" fill="#db2777" />
                      <rect x="28" y="30" width="18" height="4" rx="2" fill="#db2777" />
                      <circle cx="20" cy="44" r="3.5" fill="#db2777" />
                      <rect x="28" y="42" width="18" height="4" rx="2" fill="#db2777" />
                      <path d="M52 46.5L47.5 49L48.5 44L44.5 40.5L49.5 40L52 35L54.5 40L59.5 40.5L55.5 44L56.5 49L52 46.5Z" fill="#db2777" stroke="white" strokeWidth="2.5" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <span className="text-[7.5px] min-[360px]:text-[8.5px] sm:text-[10px] font-bold text-[#db2777] leading-tight uppercase tracking-wider">Exam-Focused<br />Resources</span>
                </div>
              </div>
            </div>

            <p class="mx-auto mb-5 max-w-[528px] text-xl font-semibold text-[#ef305c] underline lg:mb-8 ">India's best self understandable notes</p>
            {/* <!-- Button Wrap --> */}
            <div className="grid grid-cols-2 gap-4 md:flex md:justify-center md:gap-6 w-full max-w-5xl mx-auto mt-4 px-2">
              {/* 1st Year */}
              <Link to='/notessubject?year=1st'
                data-aos="fade-up"
                className="group flex w-full md:w-56 flex-row items-center justify-between rounded-xl border border-solid border-[#ef305c] px-2.5 py-3.5 sm:px-4 font-semibold text-[#ef305c] [box-shadow:rgb(19,_83,_254)_6px_6px] bg-white transition-all duration-250 hover:translate-y-[-3px] hover:[box-shadow:rgb(19,_83,_254)_8px_8px] hover:bg-gray-50/50">
                <div className="flex items-center gap-1.5 sm:gap-3">
                  {/* Circle with Blue Book Icon */}
                  <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-[#eff6ff] flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4 sm:w-4.5 sm:h-4.5 text-[#1353fe]" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25"></path>
                    </svg>
                  </div>
                  <p className="text-black font-semibold text-sm sm:text-base whitespace-nowrap group-hover:text-[#ef305c] transition-colors duration-200">1st Year</p>
                </div>
                {/* Circle with Blue Right Arrow */}
                <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0 text-[#1353fe]">
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"></path>
                  </svg>
                </div>
              </Link>

              {/* 2nd Year */}
              <Link to='/notessubject?year=2nd'
                data-aos="fade-up"
                className="group flex w-full md:w-56 flex-row items-center justify-between rounded-xl border border-solid border-[#ef305c] px-2.5 py-3.5 sm:px-4 font-semibold text-[#ef305c] [box-shadow:rgb(19,_83,_254)_6px_6px] bg-white transition-all duration-250 hover:translate-y-[-3px] hover:[box-shadow:rgb(19,_83,_254)_8px_8px] hover:bg-gray-50/50">
                <div className="flex items-center gap-1.5 sm:gap-3">
                  {/* Circle with Green Mortarboard Icon */}
                  <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-[#f0fdf4] flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4 sm:w-4.5 sm:h-4.5 text-[#15803d]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l9-5-9-5-9 5 9 5z" />
                      <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
                      <path strokeLinecap="round" strokeLinejoin="round" d="M6 12.5V16a6 6 0 0012 0v-3.5" />
                    </svg>
                  </div>
                  <p className="text-black font-semibold text-sm sm:text-base whitespace-nowrap group-hover:text-[#ef305c] transition-colors duration-200">2nd Year</p>
                </div>
                {/* Circle with Green Right Arrow */}
                <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0 text-[#15803d]">
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"></path>
                  </svg>
                </div>
              </Link>

              {/* 3rd Year */}
              <Link to='/notessubject?year=3rd'
                data-aos="fade-up"
                className="group flex w-full md:w-56 flex-row items-center justify-between rounded-xl border border-solid border-[#ef305c] px-2.5 py-3.5 sm:px-4 font-semibold text-[#ef305c] [box-shadow:rgb(19,_83,_254)_6px_6px] bg-white transition-all duration-250 hover:translate-y-[-3px] hover:[box-shadow:rgb(19,_83,_254)_8px_8px] hover:bg-gray-50/50">
                <div className="flex items-center gap-1.5 sm:gap-3">
                  {/* Circle with Orange Lightbulb Icon */}
                  <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-[#fff7ed] flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4 sm:w-4.5 sm:h-4.5 text-[#ea580c]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364.364l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                    </svg>
                  </div>
                  <p className="text-black font-semibold text-sm sm:text-base whitespace-nowrap group-hover:text-[#ef305c] transition-colors duration-200">3rd Year</p>
                </div>
                {/* Circle with Orange Right Arrow */}
                <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0 text-[#ea580c]">
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"></path>
                  </svg>
                </div>
              </Link>

              {/* 4th Year */}
              <Link to='/notessubject?year=4th'
                data-aos="fade-up"
                className="group flex w-full md:w-56 flex-row items-center justify-between rounded-xl border border-solid border-[#ef305c] px-2.5 py-3.5 sm:px-4 font-semibold text-[#ef305c] [box-shadow:rgb(19,_83,_254)_6px_6px] bg-white transition-all duration-250 hover:translate-y-[-3px] hover:[box-shadow:rgb(19,_83,_254)_8px_8px] hover:bg-gray-50/50">
                <div className="flex items-center gap-1.5 sm:gap-3">
                  {/* Circle with Pink Stethoscope Icon */}
                  <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-[#fdf2f8] flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4 sm:w-4.5 sm:h-4.5 text-[#db2777]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19 3v8a7 7 0 01-14 0V3M5 3h4M15 3h4M12 11v8a3 3 0 106 0v-4m0 0a2 2 0 10-4 0" />
                    </svg>
                  </div>
                  <p className="text-black font-semibold text-sm sm:text-base whitespace-nowrap group-hover:text-[#ef305c] transition-colors duration-200">4th Year</p>
                </div>
                {/* Circle with Pink Right Arrow */}
                <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0 text-[#db2777]">
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"></path>
                  </svg>
                </div>
              </Link>
            </div>
          </div>
          {/* <!-- Image Div --> */}
          <div class="relative mx-auto md:h-[512px]" data-aos="flip-left">
            <img src="/img/hero-banner.jpeg" alt="" class="inline-block h-full w-full rounded-xl object-cover sm:rounded-2xl" />
            <div class="absolute bottom-0 left-4 right-0 top-4 -z-10 h-full w-full rounded-2xl bg-black"></div>
          </div>
        </div>

        <img src="https://assets.website-files.com/63904f663019b0d8edf8d57c/63905b9f809b5c8180ce30c5_pattern-1.svg" alt="" class="absolute bottom-0 left-0 right-auto top-auto -z-10 inline-block md:bottom-1/2 md:left-0 md:right-auto md:top-auto" />
        <img src="https://assets.website-files.com/63904f663019b0d8edf8d57c/63905ba1538296b3f50a905e_pattern-2.svg" alt="" class="absolute bottom-auto left-auto right-0 top-0 -z-10 hidden sm:inline-block" />
      </section>
    </>

  )
}

export default Hero
